<template>
    <div class="inputs">
        <h5>Trocar Senha</h5>
        <Loading/>

        <span>Cadastre uma nova senha para o seu usuário</span>
        <input type="password" v-model="senha" id="senha" class="form-control mb-2" placeholder="Nova Senha"/>
        <input type="password" v-model="csenha" id="csenha" class="form-control mb-3" placeholder="Confirmar senha"/>

        <button class="btn col-12 conectar text-white" type="button" @click="rsenha">Trocar Senha</button>
    </div>
</template>

<script>
    let axios = require('axios');
    import Loading from './Loading';

    export default {
        name: 'RecSenha',

        data() {
            return {
                csenha: '',
                senha: '',
            }
        },

        components:{
            Loading
        },

        methods: {
            rsenha() {
                if(this.csenha !== this.senha){
                    this.$swal('As senhas não confererem', 'Tente novamente', 'error');
                    return;
                }

                if(this.senha.length < 6){
                    this.$swal('A senha deve ter pelo menos 6 caracteres', 'Tente novamente', 'error');
                    return;
                }

                let thisVue = this;


                API.enviarRequisicao('post', '/api/controleacesso/usuarios/trocaSenha', {
                    ba01_usuario: thisVue.$parent.usuario,
                    ba01_senha: this.senha
                }).then(function (resp) {
                    thisVue.$swal('Senha alterada com sucesso','','success').then(function () {
                        thisVue.$router.go('/');
                    });
                }).catch(function () {
                    thisVue.$swal('Erro de conexão com o servidor', '', 'error');
                });
            }
        }
    }
</script>

<style scoped>
    .inputs {
        color: #888;
    }
    .conectar {
        background-color: #141E37;
        border-bottom: 4px solid #505a82;
    }
    button:hover {
        background-color: #030d26 !important;
    }
   
</style>
